angular.module('bmsApp.trugreen.quote').controller('TGQuoteIndexCtrl',
	function ($state,
			  $scope,
			  ngTableParams,
			  TGJobSvc,
			  LicenseOptionsSvc,
			  InstanceSvc,
			  $cookies,
				$localStorage) {


		var defaultTableParams = function () {
			return {
				page: 1, // show first page
				count: $scope.config.table.params.count, // count per page
				sorting: {
					id: 'desc' // initial sorting
				},
				filter: {
					search: '',
					converted: false,
					quoteStatus: [1],
					proforma: false,
					licences: null,
				}
			};
		};

		var initialParams = function () {
			if (angular.isDefined($localStorage.tgQuoteIndexParams)) {
				self.searchText = $localStorage.tgQuoteIndexParams.filter.search;
				return angular.extend({}, defaultTableParams(), $localStorage.tgQuoteIndexParams);
			}
			else {
				return angular.extend({}, defaultTableParams());
			}
		};

		function init() {
			self.ecomEnabled = InstanceSvc.instance.ecomEnabled();
			self.quoteStatusOptions = [
				{
					value: 1,
					label: 'Open'
				},
				{
					value: 3,
					label: 'Lost'
				}
			];
			self.confirmedStatusOptions = [
				{
					value: 1,
					label: 'Unconfirmed'
				},
				{
					value: 0,
					label: 'Confirmed'
				}
			];


			LicenseOptionsSvc.license().then(function (response) {
				$scope.licenseOptions = response.data.options;
				// self.licenses = response.data.options;
			});

			var params = initialParams();
			self.quoteFilters = angular.copy(params.filter);

			self.tableParams = new ngTableParams(params, {
				total: 0, // length of datagetData: function ($defer, params) {
				counts: $scope.config.table.settings.counts, // available page counts
				getData: function ($defer, params) {
					$localStorage.tgQuoteIndexParams = params.$params;
					TGJobSvc.quoteIndex(params.$params)
						.then(function (response) {
							params.total(response.data.tg_job_filtered_count);
							$defer.resolve(response.data.tg_job_collection);
							$scope.$emit('quoteIndexUpdated', {
								quote_collection: response.data.tg_job_collection,
								quote_filtered_count: response.data.tg_job_filtered_count,
								quote_total_count: response.data.tg_job_total_count,
								quote_total_value: response.data.total_quote_value,
								'quotes_over_28_days': response.data.total_over_28_days
							});
							// Check if we've exceeded our page size, if we have, go back
							if (response.data.tg_job_filtered_count > 0 && !response.data.tg_job_collection.length) {
								let newParams = angular.copy(self.tableParams.$params);
								newParams.page--;
								angular.extend(self.tableParams.$params, newParams);
							}
							self.loading = false;
						});
				}
			});
		}

		// text search
		function filterChanged() {
			self.tableParams.$params.filter.search = self.searchText;
		}

		// Store the table params whenever anything changes
		$scope.$watch('tableParams.$params', function (value) {
			if (angular.isObject(value)) {
				$cookies.tgQuoteIndexParams = JSON.stringify(value);
			}
		}, true);

		// other filters
		function filterApply() {
			angular.extend(self.tableParams.$params.filter, angular.copy(self.quoteFilters));
		}

		function filterReset() {
			angular.extend(self.tableParams.$params, defaultTableParams());
			angular.extend(self.quoteFilters, defaultTableParams().filter);
		}

		function rowClicked (quote) {
			$state.go('main.trugreen.quote.index.view', {
				quoteId: quote.id
			});
		}

		var self = $scope.TGQuoteIndexCtrl = {
			loading: true,
			searchText: '',
			tableParams: null,
			licenses: null,
			quoteFilters: null,
			quoteStatusOptions: null,
			methods: {
				init: init,
				filterChanged: filterChanged,
				filterApply: filterApply,
				filterReset: filterReset,
				rowClicked: rowClicked
			}
		}


	});
